import type { TextBlockModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import ContentModifierComponent from "./base/ContentModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import ProductSelectorModifier from "./base/ProductSelectorModifier";
import StyleModifier from "./base/StyleModifier";
import TextAlignmentModifierComponent from "./base/TextAlignmentModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useSelectedElement } from "./store/ModifiersStoreContext";

interface TextModifierBlockProps {
  onModifiersValueChange: (modifiers: TextBlockModifierValue[]) => void;
}

const TextModifierBlock: React.FC<TextModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const selectedElement = useSelectedElement();

  const sections = [
    ...(selectedElement?.props?.productId
      ? [
          {
            rows: [
              {
                title: "Product",
                component: (
                  <ProductSelectorModifier onChange={onModifiersValueChange} />
                ),
              },
            ],
          },
        ]
      : []),
    {
      rows: [
        {
          title: "Content",
          component: (
            <ContentModifierComponent onChange={onModifiersValueChange} />
          ),
        },
        {
          title: "Alignment",
          component: (
            <TextAlignmentModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Style",
          component: <StyleModifier onChange={onModifiersValueChange} />,
        },
        {
          title: "Color",
          component: (
            <TextColorModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent onChange={onModifiersValueChange} />
          ),
        },
      ],
    },
  ];

  return <ModifierLayout sections={sections} />;
};

export default TextModifierBlock;
